/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import JobPageMeta from "@/src/containers/Pages/Generic/JobsPage/JobPageMeta";
import JobsSection from "@/src/components/Jobs/JobsSection";
import WayWeWorkSection from "@/src/components/Jobs/WayWeWorkSection";
import JobBenefits from "@/src/components/Jobs/JobBenefits.tsx";
import Layout from "@/src/containers/Layouts/Layout";

const JobOverviewPage = () => {
  return (
    <Layout backgroundType={"landingpage"}>
      <JobPageMeta />
      <WayWeWorkSection />
      <JobsSection />
      <JobBenefits />
    </Layout>
  );
};

export default JobOverviewPage;
